import { getText } from '@educaplay/app-core/language';
import { timestampToLongDate } from '@educaplay/app-core/time';
import { PAYMENT_METHODS } from './constants';
import config from '../resources/config.json';

export const renewalText = (key, values = {}) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll('{' + name + '}', value), getText(key));

export const RenewalText = ({ textKey, values = {} }) => renewalText(textKey, values).split(/(<b>.*?<\/b>)/).map((part, index) =>
    part.startsWith('<b>') ? <strong key={ index }>{ part.slice(3, -4) }</strong> : part
);

export { declineReason } from '@educaplay/app-core/renewal';

export const renewalErrorText = (errors) => getText('renewal_error_' + (config.renewal.errors.includes(errors?.[0]) ? errors[0] : 'unknown'));

export const renewalValues = (pendingRenewal, environment) => ({
    plan: getText('plan_name_' + pendingRenewal.license),
    importe: new Intl.NumberFormat(environment.lang, { style: 'currency', currency: pendingRenewal.currency, minimumFractionDigits: pendingRenewal.decimals, maximumFractionDigits: pendingRenewal.decimals }).format(pendingRenewal.amount)
});

export const renewalPaymentMethodType = (pendingRenewal, payerMode) => ((pendingRenewal.payer === false) || payerMode) ? (pendingRenewal.paymentMethod?.type ?? false) : false;

export const nextRetryKey = (pendingRenewal, payerMode, sameCard) => {
    switch (renewalPaymentMethodType(pendingRenewal, payerMode)) {
    case PAYMENT_METHODS.CARD:
        return sameCard ? 'renewal_pending_next_retry_same_card' : 'renewal_pending_next_retry_card';
    case PAYMENT_METHODS.PAYPAL:
        return 'renewal_pending_next_retry_paypal';
    default:
        return 'renewal_pending_next_retry';
    }
};

export const nextRetryValues = (pendingRenewal) => ({
    fecha: timestampToLongDate(pendingRenewal.nextRetryDate),
    last4: pendingRenewal.paymentMethod?.description ?? ''
});
